/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { subirArchivoOrdenMedio, actualizarArchivoOrdenMedio } from "../../utils/ordenesMedio";

/**
 * "Adjuntar PDF" — retry simple para una OM cuya fila ya se creó pero cuya subida de archivo
 * falló (fix 2026-10-06, caso OM 086028/UC Christus: el nombre original del archivo rompía la key
 * de Storage). NO vuelve a pedir número/fecha/importe/vínculos — esos datos ya están guardados y
 * correctos; solo falta el PDF. Mismo paso 2+3 que el modal de Cargar/Reemplazar
 * (`subirArchivoOrdenMedio` + `actualizarArchivoOrdenMedio`), sin el paso 1 (la fila ya existe).
 *
 * Props: show, onHide, omInfo ({ omId, pais, numeroOm }), onSaved.
 */
export const AdjuntarPdfOmModal = ({ show, onHide, omInfo, onSaved }) => {
  const [archivo, setArchivo] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) setArchivo(null);
  }, [show]);

  const handleArchivoChange = (e) => {
    const file = e.target.files?.[0] || null;
    if (file && file.type !== "application/pdf") {
      toast.error("La Orden de Medio tiene que ser un PDF");
      e.target.value = "";
      setArchivo(null);
      return;
    }
    setArchivo(file);
  };

  const handleGuardar = async () => {
    if (!archivo || !omInfo) return;
    setSaving(true);
    try {
      const archivoPath = await subirArchivoOrdenMedio({ pais: omInfo.pais, ordenMedioId: omInfo.omId, file: archivo });
      await actualizarArchivoOrdenMedio({ id: omInfo.omId, archivoPath, archivoNombreOriginal: archivo.name });
      toast.success(`PDF adjuntado a la OM ${omInfo.numeroOm}`);
      onSaved?.();
      onHide();
    } catch (error) {
      console.error(`Error adjuntando el PDF a la OM ${omInfo.omId}:`, error);
      toast.error(error.message || "No se pudo adjuntar el PDF — reintentá");
    } finally {
      setSaving(false);
    }
  };

  if (!omInfo) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Adjuntar PDF — OM {omInfo.numeroOm}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted" style={{ fontSize: "0.85rem" }}>
          Esta OM ya tiene sus datos guardados (número, fecha, importe y vínculos) — solo falta el PDF.
        </p>
        <Form.Group>
          <Form.Label>PDF de la OM</Form.Label>
          <Form.Control type="file" accept="application/pdf" onChange={handleArchivoChange} disabled={saving} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} size="sm" disabled={saving}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleGuardar} disabled={saving || !archivo} size="sm">
          {saving ? "Guardando..." : "Guardar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
